export default __webpack_public_path__ + "static/wedding_insurance_paragraph-22caf565218fbe72ef5228c433efbdcf.webp";